




















import { Prop, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon table inline pagination component
 */
@Component
export default class TableInlinePagination extends Vue {
  @Prop() totalItemsCount!: number;
  @Prop() pageSize!: number;
  @Prop() currentPage!: number;
  @Prop() setPageNumber!: (pageNumber: number) => void;

  @Watch("currentPage") currentPageUpdated(): void {
    this.pageNumber = this.currentPage;
  }

  private pageNumber = 1;

  private get pagesCount(): number {
    return Math.ceil(this.totalItemsCount / this.pageSize);
  }

  paginationClicked(event: MouseEvent): void {
    let target: HTMLElement | null = event.target as HTMLElement;
    if (target.tagName.toLowerCase() === "i") {
      target = target.parentElement;
    }
    const targetClassList = target?.classList;
    if (
      !targetClassList?.contains("pagination__button") ||
      this.pagesCount === 0
    ) {
      return;
    }
    if (targetClassList?.contains("pagination__button--first-page")) {
      this.pageNumber = 1;
    } else if (targetClassList?.contains("pagination__button--prev")) {
      this.pageNumber = Math.max(1, this.pageNumber - 1);
    } else if (targetClassList?.contains("pagination__button--next")) {
      this.pageNumber = Math.min(this.pagesCount, this.pageNumber + 1);
    } else if (targetClassList?.contains("pagination__button--last-page")) {
      this.pageNumber = this.pagesCount;
    }
    this.invokePageNumberSetter();
  }

  private invokePageNumberSetter(): void {
    this.setPageNumber(this.pageNumber);
  }
}
